import { Box, styled } from "@mui/material";
import { CarTableMultiRow } from "@app/components/Table";
import { columns } from "./ManualAccountColumns";
import { ManualAccountRowProps } from "./manual-account-types";
import { Savings } from "./Savings";
import { ManualAccountRowSummaryPositionTable } from "./ManualAccountRowSummaryPositionTable";
import { isPercentAccount } from "@app/features/assets/account.utils";
import { isDefined, setDisplayName } from "@app/utils";
import { memo } from "react";

const StyledRoot = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const ManualAccountRowSummaryAdvanced = memo(
  (props: ManualAccountRowProps) => (
    <StyledRoot className={props.className}>
      <CarTableMultiRow
        item={props.item}
        rows={[
          [
            columns.manualType,
            columns.owner,
            columns.description,
            columns.accountType,
            columns.savings,
            columns.inputFormat,
            isPercentAccount(props.item) ? columns.marketValue : undefined,
          ].filter(isDefined),
        ]}
        onChange={props.onChange}
        onDelete={props.onDelete}
        pendoPrefix={props.pendoPrefix}
      />
      <Savings item={props.item} onChange={props.onChange} />
      <ManualAccountRowSummaryPositionTable
        item={props.item}
        onChange={props.onChange}
      />
    </StyledRoot>
  ),
);

setDisplayName({ ManualAccountRowSummaryAdvanced });
